"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1633],{

/***/ 21633:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ExpertDetail_AgencyInformation; }
});

// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@design-system-pc-virtual-9891e7a910/0/cache/@design-system-pc-npm-4.8.2-12a77acac1-f2e19fad33.zip/node_modules/@design-system/pc/dist/design-system-pc.js
var design_system_pc = __webpack_require__(39894);
// EXTERNAL MODULE: ../../.yarn/__virtual__/@display-component-pc-virtual-f58fad46bb/0/cache/@display-component-pc-npm-5.0.4-138c693e54-09ca02fce9.zip/node_modules/@display-component/pc/dist/display-component-pc.js + 3 modules
var display_component_pc = __webpack_require__(34074);
// EXTERNAL MODULE: ./src/components/ResponsiveBox/ResponsiveBox.tsx
var ResponsiveBox = __webpack_require__(78620);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/hooks/useAgencyInformation.tsx

var useAgencyInformation = function(param) {
    var id = param.id;
    var handleGoShop = (0,react.useCallback)(function() {
        window.location.href = "/shop/".concat(id);
    }, [
        id
    ]);
    return {
        handleGoShop: handleGoShop
    };
};
/* harmony default export */ var hooks_useAgencyInformation = (useAgencyInformation);

// EXTERNAL MODULE: ./src/services/tracking.ts
var tracking = __webpack_require__(19676);
;// CONCATENATED MODULE: ./src/feat-components/ExpertDetail/AgencyInformation.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var AgencyInformation = function(param) {
    var data = param.data;
    var ref, ref1, ref2;
    var handleGoShop = hooks_useAgencyInformation({
        id: data.id
    }).handleGoShop;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveBox/* default */.Z, _objectSpreadProps(_objectSpread({}, tracking/* default.tagGTM */.Z.tagGTM("agency_information")), {
        mt: 52,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, _objectSpreadProps(_objectSpread({
            space: 8,
            alignment: "start",
            onClick: handleGoShop,
            width: "max-content",
            style: {
                cursor: "pointer"
            }
        }, tracking/* default.tagGTM */.Z.tagGTM("goods_detail_shop_button", {
            "shop-id": data.id
        })), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                    space: 4,
                    width: 100,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                            variant: "ic_search_store",
                            resize: true,
                            size: 16,
                            useFillColor: true,
                            color: "color_chip.gray.700"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                            variant: "label_md_m",
                            color: "color_chip.gray.800",
                            children: "소속 대리점"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                    mt: "2px",
                    space: 16,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Box */.xu, {
                            width: 72,
                            height: 72,
                            borderRadius: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(display_component_pc/* LoadImage */.r6, {
                                src: (ref = data.image) === null || ref === void 0 ? void 0 : ref.url,
                                imgFit: "cover"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* Box */.xu, {
                            flex: "1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                    variant: "subTitle5",
                                    color: "color_chip.primary",
                                    children: data.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(design_system_pc/* HStack */.zn, {
                                    space: 4,
                                    alignment: "start",
                                    mt: "4px",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Icongraphy */.Jb, {
                                            variant: "ic_location",
                                            resize: true,
                                            size: 16,
                                            useFillColor: true,
                                            color: "color_chip.gray.700"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(design_system_pc/* Text */.xv, {
                                            variant: "body2",
                                            color: "color_chip.gray.700",
                                            flex: "1",
                                            children: "".concat((ref1 = data.address) === null || ref1 === void 0 ? void 0 : ref1.basic, " ").concat((ref2 = data.address) === null || ref2 === void 0 ? void 0 : ref2.detail)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }))
    }));
};
/* harmony default export */ var ExpertDetail_AgencyInformation = (AgencyInformation);


/***/ })

}]);